module.exports = __webpack_public_path__ + "static/img/jysk.0df78fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mimg/jysk.png
// module id = rICW
// module chunks = 4